module.exports = __webpack_public_path__ + "img/TempImg.0bd8726b.jpg";